import { HttpRequest } from '@angular/common/http';
import moment from 'moment';
import { v4 as uuid4 } from 'uuid';

export enum CACHED_REQUEST_STATUS {
    COMPLETED = 'COMPLETED',
    PENDING = 'PENDING',
    ERROR = 'ERROR',
}

export class CachedRequest {
    private url: string;
    private headers: CachedHeader | undefined;
    private payload: CachedPayload | Record<string, unknown> | undefined | unknown;
    private method: string;
    public constructor(httpRequest: HttpRequest<CachedPayload | Record<string, unknown> | unknown>) {
        this.url = httpRequest.url;
        this.payload = httpRequest?.body ?? undefined;
        this.method = httpRequest.method;
        this.headers = this.getHeaderNameAndValue(httpRequest);
    }

    private getHeaderNameAndValue(request: HttpRequest<unknown>): CachedHeader | undefined {
        const headerName = request.headers.keys();
        const header: Record<string, string> = {};

        if (headerName && headerName.length) {
            request.headers.keys().forEach((hname) => {
                const matchedValue = request.headers.get(hname);
                if (matchedValue) {
                    header[hname] = matchedValue;
                }
            });
            return header;
        } else {
            return undefined;
        }
    }

    public getUrl(): string {
        return this.url;
    }

    public getPayload(): Record<string, unknown> | undefined | unknown {
        return this.payload;
    }

    public getCachedPayloadEndpoint(): string {
        return this.payload && this.payload.hasOwnProperty('Endpoint')
            ? (<CachedPayload>this.payload).Endpoint
            : this.url;
    }

    public getHeaders(): CachedHeader | undefined {
        return this.headers;
    }

    public addAdditionalHeader(name: string): void {
        if (!this.headers) {
            this.headers = {};
        }
        this.headers[name] = name;
    }

    public createCachedPOSTRequest(): CachedPOSTRequest {
        return {
            id: uuid4().toString(),
            url: this.getUrl(),
            headers: this.getHeaders(),
            body: this.getPayload(),
            requestStatus: CACHED_REQUEST_STATUS.PENDING,
            createdAt: moment().toISOString(),
            attempts: 0,
        };
    }
}

export interface CachedPOSTRequest {
    id: string;
    url: string;
    headers: CachedHeader | undefined;
    requestStatus: CACHED_REQUEST_STATUS;
    body: CachedPayload | Record<string, unknown> | undefined | unknown;
    createdAt?: string;
    modifiedAt?: string;
    attempts: number;
}

export interface CachedGETRequest {
    url: string;
    headers: CachedHeader | undefined;
    refreshStatus: CACHED_REQUEST_STATUS;
}

export interface CachedHeader {
    [name: string]: string | string[];
}

export const CACHED_HEADER = 'CachedHeader';
export const ONLINE_HEADER = 'OnlineHeader';

export interface CachedPayload {
    Endpoint: string;
    TimeStamp: string;
    Json: string;
}
